export class WarnReportNotification{
    public id:number
    public warnReportId:number
    public companyId:number
}